// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_MapInt from "rescript/lib/es6/belt_MapInt.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Ethers$SensumPwa from "../../blockchain/eth/ethers/Ethers.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Sensations$SensumPwa from "../../blockchain/eth/sensations/Sensations.bs.js";
import * as State_Avatar$SensumPwa from "../../state/avatar/State_Avatar.bs.js";
import * as Core_Ui_Navbar$SensumPwa from "../../core/ui/navbar/Core_Ui_Navbar.bs.js";

var privateKey = "0x25aa6fec3324277deae6b4c934338fca5ef3940529f24d8cb77c7facebd51096";

function Pages_NewSensation$MessengerInfo(Props) {
  var wallet = Props.wallet;
  var match = React.useState(function () {
        
      });
  var setBalance = match[1];
  var balance = match[0];
  React.useEffect((function () {
          var p = async function (param) {
            try {
              var b = await Ethers$SensumPwa.getWalletBalance(wallet);
              return Curry._1(setBalance, (function (param) {
                            return Caml_option.some(b);
                          }));
            }
            catch (raw_e){
              var e = Caml_js_exceptions.internalToOCamlException(raw_e);
              if (e.RE_EXN_ID === Js_exn.$$Error) {
                var msg = e._1.message;
                if (msg !== undefined) {
                  console.log("[error] getWalletBalance", msg);
                } else {
                  console.log("[error] getWalletBalance", "Some other exception has been thrown");
                }
                return ;
              }
              throw e;
            }
          };
          p(undefined);
        }), []);
  var tmp;
  if (balance !== undefined) {
    var b = Caml_option.valFromOption(balance);
    tmp = "" + b.toString() + " " + (
      b.toString() === "0" ? "(Pray for power!)" : ""
    ) + "";
  } else {
    tmp = "...";
  }
  return React.createElement("div", {
              className: "flex flex-col"
            }, React.createElement("label", {
                  className: "text-md text-purple-50 mx-1"
                }, "Messenger"), React.createElement("div", {
                  className: "flex flex-row flex-wrap mx-1 gap-2"
                }, React.createElement("label", {
                      className: "truncate text-md text-purple-50"
                    }, "* Address: ", wallet.address)), React.createElement("div", {
                  className: "flex flex-row flex-wrap mx-1 gap-2"
                }, React.createElement("label", {
                      className: "truncate text-md text-purple-50"
                    }, "* Mana: ", tmp)));
}

var MessengerInfo = {
  make: Pages_NewSensation$MessengerInfo
};

function Pages_NewSensation$CostInfo(Props) {
  var provider = Props.provider;
  var contract = Props.contract;
  var wallet = Props.wallet;
  var sensation = Props.sensation;
  var match = React.useState(function () {
        
      });
  var setCost = match[1];
  var cost = match[0];
  var updateCost = async function (param) {
    var newCost = await Sensations$SensumPwa.estimateCost(provider, contract, wallet, sensation);
    return Curry._1(setCost, (function (param) {
                  return newCost;
                }));
  };
  React.useEffect((function () {
          updateCost(undefined);
        }), [sensation]);
  return React.createElement("div", {
              className: "flex flex-row flex-wrap mx-1 gap-2"
            }, React.createElement("label", {
                  className: "truncate text-md text-purple-50"
                }, "* Estimated cost: ", cost !== undefined ? cost : "..."));
}

var CostInfo = {
  make: Pages_NewSensation$CostInfo
};

function Pages_NewSensation(Props) {
  var config = Props.config;
  var provider = Ethers$SensumPwa.getProvider(config.networkUrl);
  var contract = Sensations$SensumPwa.getContract(config, provider);
  var wallet = Ethers$SensumPwa.newWalletFromPrivateKey(privateKey, provider);
  var match = React.useState(function () {
        return false;
      });
  var setTransmittingSensation = match[1];
  var trasmittingSensation = match[0];
  var match$1 = React.useState(function () {
        return {
                avatar: Ethers$SensumPwa.toBigInt(0),
                message: ""
              };
      });
  var setSensation = match$1[1];
  var sensation = match$1[0];
  var match$2 = React.useState(function () {
        return /* AboutToSelect */1;
      });
  var setPickingAvatar = match$2[1];
  var pickingAvatar = match$2[0];
  var onChangeSensationMessage = function ($$event) {
    var message = $$event.target.value;
    Curry._1(setSensation, (function (prev) {
            return {
                    avatar: prev.avatar,
                    message: message
                  };
          }));
  };
  var onTransmitSensation = async function (param) {
    if (sensation.message === "") {
      console.log("[error] onTransmitSensation", "sensation.message is empty");
      return ;
    }
    Curry._1(setTransmittingSensation, (function (param) {
            return true;
          }));
    try {
      var confirmedTx = await Sensations$SensumPwa.newSensation(contract, sensation, wallet);
      Curry._1(setTransmittingSensation, (function (param) {
              return false;
            }));
      console.log("[ok] onTransmitSensation::Sensations.newSensation", confirmedTx);
      return RescriptReactRouter.push("/dsensum/#graveyard");
    }
    catch (raw_e){
      var e = Caml_js_exceptions.internalToOCamlException(raw_e);
      if (e.RE_EXN_ID === Js_exn.$$Error) {
        Curry._1(setTransmittingSensation, (function (param) {
                return false;
              }));
        var msg = e._1.message;
        if (msg !== undefined) {
          console.log("[error] onTransmitSensation::Sensations.newSensation", msg);
        } else {
          console.log("[error] onTransmitSensation::Sensations.newSensation", "Some other exception has been thrown");
        }
        return ;
      }
      throw e;
    }
  };
  var tmp;
  if (typeof pickingAvatar === "number") {
    tmp = pickingAvatar !== 0 ? React.createElement("div", {
            className: "flex flex-col bg-black"
          }, React.createElement("div", {
                className: "flex flex-row flex-nowrap bg-black"
              }, React.createElement("button", {
                    className: "my-3 mx-1 w-28 h-28 bg-black flex items-center justify-center border-2 border-solid border-purple-50 text-md px-5 opacity-50 text-purple-50 hover:bg-purple-900",
                    onClick: (function (param) {
                        Curry._1(setPickingAvatar, (function (param) {
                                return /* Picking */0;
                              }));
                      })
                  }, "Pick Avatar"), React.createElement("textarea", {
                    className: "my-3 mx-1 p-2 flex-1 h-28 form-control bg-black resize-none text-lg text-purple-50 font-medium justify-center border-2  border-dotted border-purple-50 focus:outline-none focus:border-purple-900",
                    id: "newSensationMessage",
                    maxLength: 512,
                    minLength: 1,
                    placeholder: "Write your feelings...",
                    onChange: onChangeSensationMessage
                  })), React.createElement(Pages_NewSensation$MessengerInfo, {
                wallet: wallet
              }), React.createElement(Pages_NewSensation$CostInfo, {
                provider: provider,
                contract: contract,
                wallet: wallet,
                sensation: sensation
              }), React.createElement("button", {
                className: "my-1 mx-1 bg-black items-center justify-center border-2 border-solid border-purple-50 text-md px-5 text-purple-50 disabled:opacity-50",
                disabled: true
              }, "TRANSMIT SENSATION")) : React.createElement("div", {
            className: "flex flex-row bg-black flex-wrap mx-5"
          }, Belt_Array.map(State_Avatar$SensumPwa.optionsArray, (function (option) {
                  var match = option[1];
                  var pos = option[0];
                  return React.createElement("button", {
                              key: String(pos),
                              className: "my-5 mx-1 w-28 h-28 bg-black flex items-center justify-center border-2 border-solid border-purple-50 px-1 text-purple-50 hover:bg-purple-900 " + match[1] + "",
                              onClick: (function (param) {
                                  var match = Belt_MapInt.get(State_Avatar$SensumPwa.optionsMap, pos);
                                  if (match !== undefined) {
                                    var avatarCustomClass = match[1];
                                    var avatar = match[0];
                                    Curry._1(setSensation, (function (prevSensation) {
                                            return {
                                                    avatar: Ethers$SensumPwa.toBigInt(pos),
                                                    message: prevSensation.message
                                                  };
                                          }));
                                    return Curry._1(setPickingAvatar, (function (param) {
                                                  return /* Selected */{
                                                          _0: [
                                                            avatar,
                                                            avatarCustomClass
                                                          ]
                                                        };
                                                }));
                                  }
                                  console.log("Error: Avatar not found");
                                })
                            }, match[0]);
                })));
  } else {
    var match$3 = pickingAvatar._0;
    tmp = React.createElement("div", {
          className: "flex flex-col bg-black"
        }, React.createElement("div", {
              className: "flex flex-row flex-nowrap bg-black"
            }, React.createElement("button", {
                  className: "my-3 mx-1 w-32 h-28 bg-purple-900 flex items-center justify-center border-2 border-solid border-purple-50  px-1 text-purple-50 hover:bg-black " + match$3[1] + "",
                  onClick: (function (param) {
                      Curry._1(setPickingAvatar, (function (param) {
                              return /* Picking */0;
                            }));
                    })
                }, match$3[0]), React.createElement("textarea", {
                  className: "my-3 mx-1 p-2 w-full h-28 form-control bg-black resize-none text-lg text-purple-50 font-medium justify-center border-2 border-dotted border-purple-50 focus:outline-none focus:border-purple-900",
                  id: "newSensationMessage",
                  maxLength: 512,
                  minLength: 1,
                  placeholder: "Write your feelings...",
                  value: sensation.message,
                  onChange: onChangeSensationMessage
                })), React.createElement(Pages_NewSensation$MessengerInfo, {
              wallet: wallet
            }), React.createElement(Pages_NewSensation$CostInfo, {
              provider: provider,
              contract: contract,
              wallet: wallet,
              sensation: sensation
            }), React.createElement("button", {
              className: "my-1 mx-1 bg-black items-center justify-center border-2 border-solid border-purple-50 text-md px-5 text-purple-50 hover:bg-purple-900 disabled:opacity-50",
              disabled: trasmittingSensation || sensation.message === "",
              onClick: (function (param) {
                  onTransmitSensation(undefined);
                })
            }, trasmittingSensation ? "TRANSMITTING..." : "TRANSMIT SENSATION"));
  }
  return React.createElement("div", {
              className: "bg-black flex flex-col h-screen overflow-hidden"
            }, React.createElement(Core_Ui_Navbar$SensumPwa.make, {}), React.createElement("main", {
                  className: "overflow-y-scroll"
                }, tmp));
}

var make = Pages_NewSensation;

export {
  privateKey ,
  MessengerInfo ,
  CostInfo ,
  make ,
}
/* react Not a pure module */
